import { NumberInput } from '@library/components/inputs';
import { PrimaryButton } from '@library/components/buttons';
import { RankMode } from '@library/types/rankDrawer';
import { useCallback } from 'react';

interface RankDrawerBulkRankProps {
  handleBulkRank: (mode?: RankMode) => void;
  setStartingRank: (value?: number) => void;
  startingRank?: number;
}

export const RankDrawerBulkRank = ({
  handleBulkRank,
  setStartingRank,
  startingRank = undefined
}: RankDrawerBulkRankProps) => {
  const handleBulkRankChange = (value: string) => {
    const newRank = value !== '' ? Number(value) : undefined;

    if (
      (typeof newRank === 'number' && String(newRank).length < 6) ||
      typeof newRank === 'undefined'
    ) {
      setStartingRank(newRank);
    }
  };

  const handleStartingRank = useCallback(
    () => handleBulkRank(RankMode.STARTING),
    [handleBulkRank]
  );
  const handleCopyRank = useCallback(
    () => handleBulkRank(RankMode.COPIED),
    [handleBulkRank]
  );

  return (
    <div className="px-6">
      <div className="flex flex-row items-center justify-end gap-2 py-6">
        <span className="text-soClean-100 text-xs font-bold">
          SET STARTING RANK
        </span>
        <NumberInput
          className="focus:border-msJackson bg-soFresh-120 border-soFresh-140 text-soClean-100 h-8 w-14 justify-center rounded-md p-0 text-center text-sm font-medium leading-3 tracking-tight"
          onValueChange={handleBulkRankChange}
          placeholder="-"
          value={startingRank ?? ''}
          id="starting-rank-input"
        />
        <PrimaryButton
          className="flex h-8 items-center justify-center px-2 text-sm"
          disabled={typeof startingRank !== 'number'}
          handleOnClick={handleStartingRank}
          title="Rank"
        >
          Rank
        </PrimaryButton>
        <PrimaryButton
          className="flex h-8 items-center justify-center px-2 text-sm"
          disabled={typeof startingRank !== 'number'}
          handleOnClick={handleCopyRank}
          title="Rank"
        >
          Copy Rank
        </PrimaryButton>
      </div>
    </div>
  );
};
